import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { setUser, check } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (pathname.startsWith("/admin")) {
      api.post("/admin/auth/google", { session_id: sid })
        .then(() => nav("/admin", { replace: true }))
        .catch((e) => {
          toast.error(e?.response?.status === 403 ? "هذا الحساب غير مصرح له بدخول لوحة الإدارة" : "تعذّر تسجيل الدخول");
          nav("/admin/login", { replace: true });
        })
        .finally(() => check());
      return;
    }
    api.post("/auth/session", { session_id: sid })
      .then((r) => { setUser(r.data); nav("/account", { replace: true, state: { user: r.data } }); })
      .catch(() => { setUser(false); nav("/account", { replace: true }); });
  }, [nav, pathname, setUser, check]);

  return null;
}
